(function () {
	const HEADER_SELECTOR = '.header';
	const CSS_VAR = '--header-height';

	function getHeaderOuterHeight( header ) {
		const styles = getComputedStyle( header );
		const marginTop = parseFloat( styles.marginTop ) || 0;
		const marginBottom = parseFloat( styles.marginBottom ) || 0;

		return header.offsetHeight + marginTop + marginBottom;
	}

	function setHeaderHeight() {
		const header = document.querySelector( HEADER_SELECTOR );
		if ( !header ) {
			return;
		}

		document.body.style.setProperty( CSS_VAR, `${getHeaderOuterHeight( header )}px` );
	}

	function init() {
		const header = document.querySelector( HEADER_SELECTOR );
		if ( !header ) {
			return;
		}

		setHeaderHeight();

		window.addEventListener( 'resize', setHeaderHeight );

		if ( typeof ResizeObserver !== 'undefined' ) {
			new ResizeObserver( setHeaderHeight ).observe( header );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
})();
